// src/features/system/orchestrator/api/workflowsApi.ts
import { bff } from '@/lib/http/bff';

export interface WorkflowCatalogEntry {
  workflow_key: string;
  version: number;
  definition: unknown;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ListWorkflowsParams {
  active?: boolean;
  workflow_key?: string;
  version?: number;
}

export const fetchWorkflowsApi = (params: ListWorkflowsParams = {}): Promise<WorkflowCatalogEntry[]> =>
  bff.get<WorkflowCatalogEntry[]>('/orchestrator/workflow-catalog', {
    active      : params.active,
    workflow_key: params.workflow_key,
    version     : params.version,
  });

export interface CreateWorkflowInput {
  workflow_key: string;
  version: number;
  definition: unknown;
  is_active?: boolean;
}

export const createWorkflowApi = (payload: CreateWorkflowInput): Promise<WorkflowCatalogEntry> =>
  bff.post<WorkflowCatalogEntry>('/orchestrator/workflow-catalog', payload);

export interface UpdateWorkflowInput {
  definition: unknown;
  is_active?: boolean;
}

export const updateWorkflowApi = (workflowKey: string, version: number, payload: UpdateWorkflowInput): Promise<WorkflowCatalogEntry> =>
  bff.put<WorkflowCatalogEntry>(
    `/orchestrator/workflow-catalog/${workflowKey}/${version}`,
    payload
  );

export const deleteWorkflowApi = (workflowKey: string, version: number): Promise<void> =>
  bff.del<void>(`/orchestrator/workflow-catalog/${workflowKey}/${version}`);

export const setWorkflowActiveApi = (workflowKey: string, version: number, is_active: boolean): Promise<void> =>
  bff.patch<void>(
    `/orchestrator/workflow-catalog/${workflowKey}/${version}/active`,
    { is_active }
  );

export interface StartWorkflowResponse {
  workflow_run_id: string;
  workflow_id: string;
  status: string;
}

export interface TriggerWorkflowInput {
  workflow_key: string;
  version?: number;
  inputs?: Record<string, unknown>;
  run_metadata?: Record<string, unknown>;
}

/**
 * Public workflow entrypoint via BFF:
 * POST /bff/orchestrator/workflows/trigger -> orchestrator POST /workflows/start
 */
export const triggerWorkflowApi = (payload: TriggerWorkflowInput): Promise<StartWorkflowResponse> =>
  bff.post<StartWorkflowResponse>('/orchestrator/workflows/trigger', payload);
